import * as React from 'react';
import * as moment from 'moment';
import * as numeral from 'numeral';
import ZoneSelect from '../../components/cart/zone-select';
import { sumPrices } from '../../helpers/pricing-helpers';
import { CombineCartViewProps } from '../../components/cart/cart-item';

const CartItemView: React.StatelessComponent<CombineCartViewProps> = props => {

    return (
        <li className="" key={props.itemId}>

            <div className="stack-sm">
                {
                    props.itemTitle ?
                        <div className="flex-between">

                            <p className="h1-secondary small align-self-center">{props.itemTitle}</p>

                            {
                                props.showRemoveButton ?
                                    <button type="button" className="btn-remove" onClick={() => props.removeItem(props.itemIdToRemove)}>
                                        {props.text.removeButtonText}
                                    </button>
                                    : null
                            }
                        </div>
                        : null
                }
                <div className="no-margins">
                    <p className="small">{props.itemDateString} {props.itemTimeString}</p>
                    <p className="small">{props.itemFacility}</p>
                </div>

            </div>
            {
                props.isUnseated
                    ?
                    <ZoneSelect showPriceTypeError={true} itemId={props.itemId} selectedZone={props.selectedZone} />
                    : null
            }

            {
                props.selectedZoneId < 1 || !props.showChangeZoneButton ? null
                    :
                    <div className="">
                        <button type="button" className="un-button body primary-link no-transform" onClick={() => props.removeZone(props.itemId)}>
                            {props.text.changeZoneButtonText}
                        </button>
                    </div>
            }

            {
                props.itemProcessErrorMessage.length > 0 ?
                    <span className="field-validation-error">{props.itemProcessErrorMessage}</span>
                    : null
            }
        </li>
    );
}

export default CartItemView;